import { useConst } from "@chakra-ui/react";
import { AsyncReturnType } from "type-fest";

import { TypeaheadService } from "@/services";
import { UseQuerySimpleOptions, useQuery } from "@/services/hooks";
import { gen, repeat } from "@/utils";

type QueryArgs = Parameters<typeof TypeaheadService.getIndustries>[0];
type QueryFnData = AsyncReturnType<typeof TypeaheadService.getIndustries>;
type Error = unknown;

const queryKey = (args: QueryArgs = {}) => ["typeahead", "industries", args];

export const useIndustries = <TData = QueryFnData>(
  args: QueryArgs = {},
  options?: UseQuerySimpleOptions<QueryFnData, Error, TData>
) => {
  const result = useQuery<QueryFnData, Error, TData>(
    queryKey(args),
    () => TypeaheadService.getIndustries(args),
    {
      skeletonData: useConst({
        elements: repeat(gen.typeahead),
        pagination: {
          skip: 0,
          limit: 10,
          total: 2,
        },
      }),
      ...options,
    }
  );

  return result;
};

useIndustries.queryKey = queryKey;
